export const IMAGE_STYLE_PROPS = {
  fit: 'cover',
  width: '100%',
  height: '100%',
  radius: 'sm',
} as const
